import { render, staticRenderFns } from "./draw.vue?vue&type=template&id=c2462f60&scoped=true"
import script from "./draw.vue?vue&type=script&lang=ts"
export * from "./draw.vue?vue&type=script&lang=ts"
import style0 from "./draw.vue?vue&type=style&index=0&id=c2462f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2462f60",
  null
  
)

export default component.exports